import {DocumentFormProps} from "./DocumentForm";
import {FieldDate, FieldInput} from "@kroschke/react-ui";
import {DocumentFormDefault} from "./DocumentFormDefault";

function DocumentFormCorII({
                               disabled,
                               value,
                               onBlur,
                               validation,
                               onChange
                           }: DocumentFormProps) {
    return <>
        <div className={"columns"}>
            <div className={"column is-one-third"}>
                <FieldInput
                    disabled={disabled}
                    label={"Briefnummer"}
                    required={true}
                    maxLength={8}
                    value={value.corNumber}
                    help={validation.corNumber}
                    invalid={Boolean(validation.corNumber)}
                    onBlur={() => !disabled && onBlur()}
                    inputTransform={e => e.toUpperCase()}
                    onChange={corNumber => {
                        onChange({
                            ...value,
                            corNumber: corNumber
                        })
                    }}
                />
            </div>
            <div className={"column is-one-third"}>
                <FieldInput
                    disabled={disabled}
                    label={"FIN Prüfziffer"}
                    required={true}
                    maxLength={1}
                    value={value.vinCheckDigit || ''}
                    help={validation.vinCheckDigit}
                    invalid={Boolean(validation.vinCheckDigit)}
                    onBlur={() => !disabled && onBlur()}
                    inputTransform={e => e.toUpperCase()}
                    onChange={vinCheckDigit => {
                        onChange({
                            ...value,
                            vinCheckDigit: vinCheckDigit
                        })
                    }}
                />
            </div>
            <div className={"column is-one-third"}>
                <FieldInput
                    disabled={disabled}
                    label={"Kennzeichen"}
                    value={value.licensePlate}
                    help={validation.licensePlate}
                    invalid={Boolean(validation.licensePlate)}
                    onBlur={() => !disabled && onBlur()}
                    inputTransform={e => e.toUpperCase()}
                    onChange={licensePlate => {
                        onChange({
                            ...value,
                            licensePlate: licensePlate
                        })
                    }}
                />
            </div>
        </div>
        <div className={"columns"}>
            <div className={"column is-half"}>
                <FieldDate
                    disabled={disabled}
                    label={"Erstzulassungsdatum"}
                    value={value.registrationDateFirst}
                    help={validation.registrationDateFirst}
                    invalid={Boolean(validation.registrationDateFirst)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={registrationDateFirst => {
                        onChange({
                            ...value,
                            registrationDateFirst: registrationDateFirst
                        })
                    }}
                />
            </div>
            <div className={"column is-half"}>
                <FieldDate
                    disabled={disabled}
                    label={"Zulassungsdatum (aktuelles)"}
                    value={value.registrationDateLatest}
                    help={validation.registrationDateLatest}
                    invalid={Boolean(validation.registrationDateLatest)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={registrationDateLatest => {
                        onChange({
                            ...value,
                            registrationDateLatest: registrationDateLatest
                        })
                    }}
                />
            </div>
        </div>
        <DocumentFormDefault
            disabled={disabled}
            value={value}
            validation={validation}
            onChange={onChange}
            onBlur={onBlur}
        />
    </>
}

export {
    DocumentFormCorII
}
